import React from 'react'
import { Typography, FormGroup } from '@mui/material'
import { FormControlLabel, Checkbox } from '@mui/material'

import { useSignupFormContext } from '../../contexts'

export const WorksChecklist = ({ options }) => {
  const { installerWorks, setInstallerWorks } = useSignupFormContext()

  const handleChange = (e) => {
    setInstallerWorks({ ...installerWorks, [e.target.name]: e.target.checked })
  }

  return (
    <FormGroup>
      {options.map((option) => (
        <FormControlLabel
          key={option.key}
          style={{ pointerEvents: 'none' }}
          control={
            <Checkbox
              style={{ pointerEvents: option.readOnly ? 'none' : 'auto', padding: 10 }}
              color="primary"
              checked={option.readOnly ? true : !!installerWorks[option.key]}
              onChange={option.readOnly ? undefined : handleChange}
              disabled={option.readOnly}
              name={option.key}
            />
          }
          label={<Typography variant="body1">{option.label}</Typography>}
        />
      ))}
    </FormGroup>
  )
}
